module.exports = __webpack_public_path__ + "static/sacrificial-greatsword-c694fc186bd842ebe51045e8e204d6f3.png";